import {create} from 'zustand';
import {ITimezonesState, TimezoneType} from './types';
import {$api} from 'shared/api';

export const useTimezonesStore = create<ITimezonesState>((set, get) => ({
  timezones: [],

  getTimezones: async () => {
    const path = `/timezones/`;
    const res = await $api.get<TimezoneType[]>(path);

    const items: TimezoneType[] = res.data ?? [];
    set({timezones: items});
  },
}));
